/**
 * The user's bubble in a conversation: the chat panel (`BirdMessage`), a Live
 * run transcript's original lines (`LiveTranscriptOriginal`) and its note body
 * (`SpeakerTurns`). Bower's turns carry no bubble anywhere, so this is the one
 * filled thing in a thread.
 *
 * Parchment, no hairline, the corner sharp on the BOTTOM RIGHT, the edge
 * nearest where the user's text came from. The reasoning for each choice is
 * on the chat bubble in `BirdMessage`.
 *
 * It lives here because the transcript copied the chat's bubble by hand and
 * picked a different fill, which vanished on the dark drawer (1.01:1). One
 * object, spread at every site, so the next surface cannot drift the same way.
 */
export const USER_BUBBLE = {
  maxW: '85%',
  bg: 'bg.surface',
  px: '14px',
  py: '10px',
  borderRadius: '2xl',
  borderBottomRightRadius: 'sm',
} as const;
